export default "__VITE_ASSET__9u5XI$nx__"